import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { billingQKeys } from "./queryKeys";


const select = (res: any) => {
  // console.log(res.data);

  if (Object.keys(res.data).length) {
    const { files } = res.data;

    // console.log(files);
    return [...files];
  }
  return null;
};

interface QueryProps {
  billId: string;
  isEnabled?: boolean;
}

export const useGetInvoice = ({ billId, isEnabled = true }: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: billingQKeys.invoice(billId),
    queryFn: () => {
      return api.get(`billing/invoice/${billId}`);
    },
    select,
    enabled: isEnabled,

    onError: (res: any) => {
      console.error("[From Get Invoice]", res);
      handleErrors(res, "query");
    },
  });
};
